const DEFAULT_SUPPORT_HANDLE = "lightpaysupport";

const extractHandle = (rawValue) => {
  const raw = String(rawValue || "").trim();
  if (!raw) return DEFAULT_SUPPORT_HANDLE;

  if (raw.startsWith("http://") || raw.startsWith("https://")) {
    try {
      const parsed = new URL(raw);
      const firstPathPart = (parsed.pathname || "").split("/").filter(Boolean)[0];
      if (firstPathPart) return firstPathPart.replace(/^@/, "");
      return DEFAULT_SUPPORT_HANDLE;
    } catch (_) {
      return DEFAULT_SUPPORT_HANDLE;
    }
  }

  const withoutPrefix = raw.replace(/^@/, "");
  const fromShortLink = withoutPrefix.match(/t\.me\/([A-Za-z0-9_]+)/i);
  if (fromShortLink?.[1]) return fromShortLink[1];

  return withoutPrefix || DEFAULT_SUPPORT_HANDLE;
};

export const getSupportTelegramUrl = () => {
  const handle = extractHandle(process.env.REACT_APP_SUPPORT_TELEGRAM);
  return `https://t.me/${handle}`;
};

export const openSupportChat = (telegram) => {
  const url = getSupportTelegramUrl();

  try {
    if (telegram?.openTelegramLink) {
      telegram.openTelegramLink(url);
      return;
    }
  } catch (_) {
    // fallback below
  }

  try {
    if (telegram?.openLink) {
      telegram.openLink(url);
      return;
    }
  } catch (_) {
    // fallback below
  }

  if (typeof window !== "undefined") {
    window.open(url, "_blank", "noopener,noreferrer");
  }
};
